import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { PlotDefinition } from 'src/modules/enaio/shared/PlotDefinition';
import { PlotReducer } from 'src/modules/enaio/shared/PlotReducer';
import { PlotType } from 'src/modules/enaio/shared/PlotType';
import { Utils } from 'src/modules/utils/shared/utils';
import { FrontendFieldAddon } from '../../models/frontend-field-addon.model';
import { FrontendFieldDefinition } from '../../models/frontend-field-definition.model';
import { FrontendFieldListItem } from '../../models/frontend-field-list-item.model';
import { FrontendFieldType } from '../../models/frontend-field-type.enum';
import { FrontendFormDefinition } from '../../models/frontend-form-definition.model';
import { GenericFieldDefinition } from '../../models/generic-field-definition.model';

@Component({
  selector: 'app-plot-definition',
  templateUrl: './plot-definition.component.html',
  styleUrl: './plot-definition.component.scss'
})
export class PlotDefinitionComponent {

    app = inject(MainAppService);

    @Input()
    templates: PlotDefinition[];
    @Input()
    fields: GenericFieldDefinition[];
    @Input()
    plot: PlotDefinition;

    @Output()
    onStoreTemplate = new EventEmitter<PlotDefinition>();

    form: FrontendFormDefinition;

    public generateForm(): void {
        let reducerListItems = [
            new FrontendFieldListItem(PlotReducer.none, "Keiner"),
            new FrontendFieldListItem(PlotReducer.count, "Anzahl")
        ];

        let emptyPlot = new PlotDefinition();
        this.form = new FrontendFormDefinition([
            this.templates == null ? null : new FrontendFieldDefinition("template", "Gespeicherte Vorlagen", FrontendFieldType.comboBox, { dropdownEditable: false, noMapping: true, value: emptyPlot,
                onValueChanged: this.selectTemplate.bind(this),
                onAddOnClick: this.storeTemplate.bind(this),
                listItems: [new FrontendFieldListItem(emptyPlot, "--Neu--"), ...this.templates.map(plot => new FrontendFieldListItem(plot, plot.name))],
                addOnButtons: [new FrontendFieldAddon("save", "", "fas fa-save", true)] }),
            new FrontendFieldDefinition("xAxisLabel", "X-Achse", FrontendFieldType.text, { hasControl: false, noMapping: true, style: { "font-weight": "bold" } }),
            new FrontendFieldDefinition("xAxis.field", "Feld", FrontendFieldType.comboBox, { mandatory: true, dropdownEditable: false, listItems: Utils.arraySortBy(this.fields, field => field.name).map(field => new FrontendFieldListItem(field.name, field.name))}),
            new FrontendFieldDefinition("xAxis.reducer", "Aggregat", FrontendFieldType.comboBox, { dropdownEditable: false, listItems: reducerListItems}),
            new FrontendFieldDefinition("xAxis.field2", "Feld 2 (optional)", FrontendFieldType.comboBox, { dropdownEditable: false,
                listItems: [new FrontendFieldListItem("", "--Ohne--"), ...Utils.arraySortBy(this.fields, field => field.name).map(field => new FrontendFieldListItem(field.name, field.name))]}),
            new FrontendFieldDefinition("yAxisLabel", "Y-Achse", FrontendFieldType.text, { hasControl: false, noMapping: true, style: { "font-weight": "bold" } }),
            new FrontendFieldDefinition("yAxis.field", "Feld", FrontendFieldType.comboBox, { mandatory: true, dropdownEditable: false, listItems: Utils.arraySortBy(this.fields, field => field.name).map(field => new FrontendFieldListItem(field.name, field.name))}),
            new FrontendFieldDefinition("yAxis.reducer", "Aggregat", FrontendFieldType.comboBox, { dropdownEditable: false, listItems: reducerListItems}),
            new FrontendFieldDefinition("yAxis.field2", "Feld 2 (optional)", FrontendFieldType.comboBox, { dropdownEditable: false,
                listItems: [new FrontendFieldListItem("", "--Ohne--"), ...Utils.arraySortBy(this.fields, field => field.name).map(field => new FrontendFieldListItem(field.name, field.name))]}),
            new FrontendFieldDefinition("colorBy", "Einfärben nach", FrontendFieldType.comboBox, { dropdownEditable: false,
                listItems: [new FrontendFieldListItem("", "--Ohne--"), ...Utils.arraySortBy(this.fields, field => field.name).map(field => new FrontendFieldListItem(field.name, field.name))]}),
            new FrontendFieldDefinition("type", "Diagrammtyp", FrontendFieldType.comboBox, { dropdownEditable: false, listItems: [
                new FrontendFieldListItem(PlotType.line, "Linie"),
                new FrontendFieldListItem(PlotType.area, "Fläche"),
                new FrontendFieldListItem(PlotType.barY, "Balken vertikal"),
                new FrontendFieldListItem(PlotType.barX, "Balken horizontal"),
                new FrontendFieldListItem(PlotType.dot, "Punkte"),
                new FrontendFieldListItem(PlotType.tickY, "Tick vertikal"),
                new FrontendFieldListItem(PlotType.tickX, "Tick horizontal"),
                new FrontendFieldListItem(PlotType.pie, "Torte")
            ]}),
            new FrontendFieldDefinition("advancedLabel", "Erweitert", FrontendFieldType.text, { hasControl: false, noMapping: true, style: { "font-weight": "bold" } }),
            new FrontendFieldDefinition("opacity", "Deckkraft", FrontendFieldType.text)
        ]);
        if (this.plot.type == null) {
            this.plot.type = PlotType.line;
        }
        this.form.fill(this.plot);
    }

    public getDefinition(): PlotDefinition {
        this.form.get(this.plot);
        this.plot.opacity = Utils.toNumber(this.plot.opacity);
        return this.plot;
    }

    private async storeTemplate(): Promise<void> {
        let name = await this.app.messageDialog.input<string>(new FrontendFieldDefinition("", "Name", FrontendFieldType.text, { mandatory: true }), "Name der Vorlage");
        if (name != null) {
            let plot = new PlotDefinition();
            this.form.get(plot);
            plot.name = name;
            this.onStoreTemplate.emit(plot);
        }
    }

    private selectTemplate(): void {
        let sel = this.form.getValue("template") as PlotDefinition;
        this.form.fill(sel);
    }
}
